export const SET_FINANCE_ERROR = 'SET_FINANCE_ERROR';
export const SET_FINANCE_LIST = 'SET_FINANCE_LIST';
export const SET_TOTAL_AMOUNT_OF_FINANCE = 'SET_TOTAL_AMOUNT_OF_FINANCE';
export const SET_FETCHING_FINANCE = 'SET_FETCHING_FINANCE';
